module.exports = __webpack_public_path__ + "static/media/Shadenet.c6dd1801.webp";